import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { getTranslation, getTranslationId } from './utils';

const AdvancementFileStatus = ({ status, className }) => {
  const translationId = getTranslationId(status);

  return (
    <span className={className}>
      <FormattedMessage id={translationId} />
    </span>
  );
};

AdvancementFileStatus.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string,
};

AdvancementFileStatus.getTranslation = getTranslation;

export default AdvancementFileStatus;
